import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GraphComponent } from './graph/graph.component';
import { RealtimeComponent } from './realtime/realtime.component';


const routes: Routes = [
    { path: '', redirectTo: 'tracks', pathMatch: 'full' },
    { path: 'tracks', component: GraphComponent, canActivate: [  ] },    
    { path: 'realtime', component: RealtimeComponent, data: {}, canActivate: [  ] },    
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
